var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Message",
    d: "M22.5,13a8.38,8.38,0,0,1-.9,3.8A8.5,8.5,0,0,1,14,21.5a8.38,8.38,0,0,1-3.8-.9L4.5,22.5l1.9-5.7A8.38,8.38,0,0,1,5.5,13a8.5,8.5,0,0,1,4.7-7.6A8.38,8.38,0,0,1,14,4.5h.5a8.48,8.48,0,0,1,8,8Z",
    transform: "translate(-3.5 -3.5)",
    fill: "none",
    stroke: "#716f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconDark);
export default __webpack_public_path__ + "static/media/message-icon-dark.f3c94d4a9ef1bee3ef56be0e8cdf1ece.svg";
export { ForwardRef as ReactComponent };